import { BReactComponent } from 'blocks-cloud/b-react-component';
import app from 'Cloud/Application/app';
import { AddToolbar as ReactToolbar } from 'reactApp/ui/Toolbar/AddToolbar';

export default () => {
    const cloudToolbarEl = document.querySelector('#cloud_toolbars');

    const toolbar = new BReactComponent({
        ReactComponent: ReactToolbar,
        renderMode: 'append',
    });

    const renderToolbar = () => {
        if (!cloudToolbarEl) {
            return;
        }

        toolbar.renderTo(cloudToolbarEl);
    };

    app.on('page:start', () => {
        renderToolbar();
    }).on('http-error routeNotFound', function () {
        toolbar.destroy();
    });
};
